import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import zeusAPI from "api/zeus";
import * as trackers from "trackers";
import sessionReducer from "./session";
import eventReducer from "./event";
import playgroundReducer from "./playground";
import { toastActions, toastMiddleware } from "./toast";
import { loggerMiddleware } from "./logger";

/* eslint-env node */
export default function configureStore() {
  const composeEnhancers =
    (typeof window !== "undefined" &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const rootReducer = combineReducers({
    session: persistReducer(
      { key: "session", storage, whitelist: ["account", "token"] },
      sessionReducer
    ),
    event: persistReducer({ key: "event", storage }, eventReducer),
    playground: playgroundReducer,
  });

  const middlewares = [
    toastMiddleware,
    thunk.withExtraArgument({
      zeusAPI,
      toast: toastActions,
      trackers,
    }),
  ];

  if (process.env.NODE_ENV === "development") {
    middlewares.push(loggerMiddleware);
  }

  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  const persistor = persistStore(store);

  return { store, persistor };
}
